import { Component, OnInit, Input, Output, EventEmitter, Inject, PLATFORM_ID } from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  Validators,
  AbstractControl,
  ValidatorFn,
} from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthService } from 'src/app/services/api/auth/auth.service';
import { CarService } from 'src/app/services/api/cars/car.service';
import { LocationService } from 'src/app/services/api/locations/location.service';
import { environment } from 'src/environments/environment';
import { ProfileService } from 'src/app/services/profile/profile.service';
import { DataLoginI } from 'src/app/interfaces/login/login.interface';
import { isPlatformBrowser } from '@angular/common';

interface RegisterFormControls {
  registerDocumento: AbstractControl;
  registerNombre: AbstractControl;
  registerApellido: AbstractControl;
  registerNacimiento: AbstractControl;
  registerCodArea: AbstractControl;
  registerNumeroTelefono: AbstractControl;
  registerEmail: AbstractControl;
  registerConfirmarEmail: AbstractControl;
  registerPassword: AbstractControl;
  registerConfirmPassword: AbstractControl;
  registerRecibirNovedades: AbstractControl;
  registerTerminosCondiciones: AbstractControl;
  registerTerminosCondicionesMarketShell: AbstractControl;
}
type PasswordCheckKey = 'uppercase' | 'lowercase' | 'number' | 'symbol' | 'minLength';
@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.scss'],
})
export class RegisterComponent implements OnInit {
  registerForm!: FormGroup;
  documentExist: boolean = false;
  emailExist: boolean = false;
  validarMktplace: boolean = false;
  registerIn: boolean = false;
  confirmRegister: boolean = false;
  errorRegister: string = '';
  showpass1: boolean = false;
  showpass2: boolean = false;
  private readonly _changePasswordEvent: Event;
  callback: string | null;
  validationEmail: boolean = false;
  isDateFocused: boolean = false;
  @Input() isModal: boolean = false;
  @Output() completeProfileEvent = new EventEmitter<{ completeProfile: boolean; preRegisteredData: any }>();

  constructor(
    private auth: AuthService,
    private car: CarService,
    private location: LocationService,
    private formBuilder: FormBuilder,
    private router: Router,
    private profileService: ProfileService,
    private activatedRoute: ActivatedRoute,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {
    this._changePasswordEvent = new Event('recuperarPassword');
    this.callback = this.activatedRoute.snapshot.queryParamMap.get('callback');
  }

  ngOnInit(): void {
    this.buildForm();

    if (isPlatformBrowser(this.platformId)) {
      document.addEventListener('loginValidated', () => {
        this.finishRegister();
      });

      document.addEventListener('loginValidatedMktPlace', () => {
        this.validarMktplace = true;
        this.finishRegister();
      });
    }

    setTimeout(() => {
      const a = new Date();
      a.setFullYear(new Date().getFullYear() - 18);
      if(isPlatformBrowser(this.platformId)) {
        document.getElementById('register-nacimiento')?.setAttribute('max', a.toISOString().split('T')[0]);
      }
    }, 500);

    this.registerForm.get('registerEmail')?.valueChanges.subscribe(() => {
      this.emailExist = false;
    });

    this.registerForm.get('registerDocumento')?.valueChanges.subscribe(() => {
      this.documentExist = false;
    });
  }

  get f(): RegisterFormControls {
    return this.registerForm.controls as unknown as RegisterFormControls;
  }

  preventCopyPaste(event: ClipboardEvent | DragEvent | MouseEvent) {
    event.preventDefault();
  }  

  onDateBlur() {
    const value = this.registerForm.get('registerNacimiento')?.value;
    if (!value) {
      this.isDateFocused = false;
    }
  }

  onCloseConfirmRegister() {
    this.closeRegister();
    this.confirmRegister = false;
  }
  
  private buildForm(): void {
    this.registerForm = this.formBuilder.group({
      registerDocumento: ['', [Validators.required, Validators.maxLength(8), Validators.pattern(/^[0-9]{7,8}$/)]],
      registerNombre: ['', Validators.required],
      registerApellido: ['', Validators.required],
      registerNacimiento: ['', [Validators.required, underEighteenValidator()]],
      registerCodArea: ['', Validators.required],
      registerNumeroTelefono: ['', Validators.required],
      registerEmail: ['', [Validators.required, Validators.email]],
      registerConfirmarEmail: ['', [Validators.required, Validators.email]],
      registerPassword: ['', [Validators.required, passwordStrengthValidator()]],
      registerConfirmPassword: ['', Validators.required],
      registerRecibirNovedades: [false],
      registerTerminosCondiciones: [false, Validators.requiredTrue],
      registerTerminosCondicionesMarketShell: [false]
    }, {
      validators: [emailMatchValidator(), passwordMatchValidator()]
    });
  }

  onDocumentBlur(): void {
    const documentValue = this.f.registerDocumento.value;
    if (documentValue) {
      const form: DataLoginI = { principal: documentValue };
      this.checkUserDocument(form);
    }
  }

  checkUserDocument(form: DataLoginI): void {
    this.auth.checkUserAccount(form.principal).subscribe({
      next: (res) => this.handleUserRedirect(res, 'document'),
      error: (err) => console.error('Error validating document:', err)
    });
  }

  onEmailBlur(): void {
    const emailValue = this.f.registerEmail.value;
    if (emailValue) {
      const form: DataLoginI = { principal: emailValue };
      this.checkUserEmail(form);
    }
  }
  
  checkUserEmail(form: DataLoginI): void {
    this.auth.checkUserAccount(form.principal).subscribe({
      next: (res) => this.handleUserRedirect(res, 'email'),
      error: (err) => console.error('Error validating email:', err)
    });
  }
  

  handleUserRedirect(response: any, source: 'document' | 'email'): void {
    try {
      const user = JSON.parse(response);
      if (user.status === "Pre-Registrado!") {
        this.profileService.updateProfileData(true, user.thalamusResponse);
        this.closeRegister();
      } else {
        if (source === 'document') {
          this.documentExist = true;
        } else if (source === 'email') {
          this.emailExist = true;
        }
      }
    } catch (error) {
      console.error('Error:', error);
    }
  }
  

  register(): void {
    this.errorRegister = '';
    this.documentExist = false;
    this.emailExist = false;

    const address = {
      countryId: 1010,
      type: 'home',
    };

    const enviar = {
      consumers: [],
      optIns: [{
        accepted: !!this.f.registerRecibirNovedades.value
      }],
      profile: {
        email: this.f.registerEmail.value,
        address,
        lastname: this.f.registerApellido.value,
        firstname: this.f.registerNombre.value,
        birthday: new Date(this.f.registerNacimiento.value).getTime(),
        tyc_marketshell_accepted: !!this.f.registerTerminosCondicionesMarketShell.value,
        tyc_shellbox_accepted: true,
        tipo_vehiculo: '',
        marca_auto: '',
        modelo_auto: '',
        ano_vehiculo: 0,
        patente_auto: '',
        cellphone: {
          intCode: '549',
          areaCode: this.f.registerCodArea.value,
          number: this.f.registerNumeroTelefono.value,
        },
        document: {
          type: 1,
          number: this.f.registerDocumento.value,
        },
      },
      credential: {
        principal: '1:' + this.f.registerDocumento.value,
        password: this.f.registerPassword.value,
      }
    };

    this.registerIn = true;
    this.auth.register(enviar, this.isModal).subscribe({
      next: () => {
          this.confirmRegister = true;
          this.registerIn = false
      },
      error: (error) => {
        this.registerIn = false;
        if (error?.error?.message === 'documentInUse') {
          this.documentExist = true;
        } else {
          this.errorRegister = error?.error?.message || 'Error al registrar';
        }
      }
    });
  }

  openLogin(): void {
    this.closeRegister();
    if (isPlatformBrowser(this.platformId)) {
      document.body.classList.add('noScroll');
      document.querySelector('.modal-login')?.classList.add('visible');
    }
  }

  closeRegister(): void {
    if (isPlatformBrowser(this.platformId)) {
      document.querySelector('.modal-register')?.classList.remove('visible');
      document.body.classList.remove('noScroll');
    }
    this.validationEmail = false;
    this.registerForm.reset();
  }

  getPartialMail(): string {
    const email = this.f.registerEmail.value || '';
    return email.replace(/(\w{3})[\w.-]+@([\w.]+\w)/, '$1***@$2');
  }

  finishRegister(): void {
    this.activatedRoute.queryParams.subscribe(params => {
      if (params['principal'] && params['token']) {
        this.auth.validateEmail(params['token'], params['principal']).subscribe({
          next: () => {
            this.validationEmail = true;
            this.isModal = true;
          },
          error: (error) =>{
            console.log(error);
          }
        });
      }
    });
  }

  cambiarPass(): void {
    this.closeRegister();
    if (isPlatformBrowser(this.platformId)) {
      document.dispatchEvent(this._changePasswordEvent);
    }
  }

  onRegistrarmeLastStepClick(): void {
    if (isPlatformBrowser(this.platformId)) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'click_Registrarme_lastStep_DL',
        boton: 'boton_Registrarme_lastStep'
      });
    }
  }

  backToHome(): void {
    if (this.validarMktplace) {
      if (isPlatformBrowser(this.platformId)) {
        document.location.href = environment.URL_MKTPLACE;
      }
    } else {
      this.router.navigate(['/']);
      this.closeRegister();
    }
  }
}

export function underEighteenValidator(): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } | null => {
    const date = new Date(control.value);
    const today = new Date();
    today.setFullYear(today.getFullYear() - 18);
    return date > today ? { underEighteen: true } : null;
  };
}

export function emailMatchValidator(): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } | null => {
    const email = control.get('registerEmail');
    const confirm = control.get('registerConfirmarEmail');
    return email && confirm && email.value !== confirm.value
      ? { emailMismatch: true }
      : null;
  };
}

export function passwordMatchValidator(): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } | null => {
    const pass = control.get('registerPassword');
    const confirm = control.get('registerConfirmPassword');
    return pass && confirm && pass.value !== confirm.value
      ? { passwordMismatch: true }
      : null;
  };
}

export function passwordStrengthValidator(): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } | null => {
    const value = control.value || '';
    const isValid =
      /[A-Z]/.test(value) &&
      /[a-z]/.test(value) &&
      /\d/.test(value) &&
      /[!@#$%^&*(),.?":{}|<>]/.test(value) &&
      value.length >= 8;

    return isValid ? null : { weakPassword: true };
  };
}
